<template>
    <div class="viewcalendarcontainer" :ref="viewuid" :id="viewuid">
        <div v-if="isLoading" class="position-relative d-none d-lg-block">
            <div v-if="showloader" class="text-center text-muted spinner-centered">
                <i class="fas fa-spinner fa-pulse fa-3x fa-fw"></i>
                <span class="sr-only">Caricamento...</span>
            </div>
            <div class="row calendar h-100 px-2 pt-2 text-muted unloaded">
                <div v-for="index in cols" :key="'placeholder' + index">
                    <div class="calcol d-block">
                        <div class="calwrapper h-100">
                            <div class="calheader">
                                <div class="calday">
                                </div>
                                <div class="caldate small text-muted">
                                </div>
                            </div>
                            <div v-for="subindex in visibleHoursBeforeHide" :key="'subplaceholder' + subindex" class="caldisp text-muted">&nbsp;</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-else-if="pagesContainer">
            <template v-if="pagesContainer.length">
                <a href="javascript:;" @click="prevPage()" aria-label="Orari precedenti" role="button" class="calarrow calarrowleft" :class="{'disabled' : cantGoBack || updatingCalendar }">
                    <i class="fas fa-chevron-left"></i>
                </a>
                <a href="javascript:;" @click="nextPage()" aria-label="Orari successivi" role="button" class="calarrow calarrowright" :class="{'disabled' : cantGoForward || updatingCalendar }">
                    <i class="fas fa-chevron-right"></i>
                </a>
            </template>
            <div class="calendars" @touchstart="touchStartMethod">
                <template v-for="(page, index) in pagesContainer">
                <div :key="'page' + index" v-if="page && page.config" class="calendar-wrapper" :id="'calendar-wrapper-' + uid + '-' + index" :class="[{'nodisp': !page.config.weekHasSlots}]">
                    <div :id="uid + '-' + index" :class="['collapse', {'show' : page.config.showClass || !page.config.weekShowMore}]">
                        <div class="row calendar mx-lg-2 h-100 pt-2 text-muted" >
                            <div v-for="(disp, dispind) in page.disp" :key="'pagedisp' + dispind" class="calcol d-block" :class="[{'nodisp': !disp.dayHasDisponibilita}, {'hasdisp' : disp.dayHasDisponibilita}]">
                                <div class="calwrapper h-100" :class="{'nodisp': !disp.dayHasDisponibilita, 'dayshaspromo' : disp.hasPromo}">
                                    <div class="calheader">
                                        <div class="calday">
                                            <span class="d-block">{{ disp.giornoLocale }}</span>
                                        </div>
                                        <div class="caldate small">
                                            <span class="d-block">{{ disp.giornoMese }}</span>
                                        </div>
                                    </div>
                                    <div v-for="(hour, ind) in disp.listOrari" :key="'listorari' + ind">
                                        <a rel="nofollow" @click="eventTrack('calendario_click', hour.ora_inizio)" :href="hour.destination" class="caldisp d-block">{{ hour.ora_inizio }}</a>
                                    </div>
    
                                    <template v-if="disp.listOrari && (disp.listOrari.length < 5 || disp.listOrari.length < page.config.weekMaxHours)">
                                        <div v-for="(indice, nodispkey) in (page.config.weekMaxHours - disp.listOrari.length)" :key="'nodisp' + nodispkey" class="caldisp text-muted nodisp">&nbsp; </div>
                                    </template>
                                </div>
                            </div>
                            <template v-if="!page.config.weekHasSlots && !page.config.isLastPage">
                                <div class="calnextdisp w-100 h-100 text-center text-dark">
                                    <div class="w-100 py-2 mb-2 rfs-6 mr-2 mr-lg-0 bg-white">{{ page.config.weekTextNextDisp }} disponibilità: <br class="d-md-none"><span v-html="page.config.nextDisp"></span></div>
                                    <a href="javascript:;" @click="jumpToPage(page.config.nextDispPagesAhead)" class="d-inline-block btn btn-outline-primary"><i class="fas fa-calendar"></i> Mostra orari disponibili</a>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="showmore-wrapper collapsed-fog"  v-if="page.config.weekShowMore">
                        <a @click="toggleShowMore()" class="mt-2 d-block text-right small" :class="{ 'collapsed' : page.config.weekCollapsed && !pageOpened }" data-toggle="collapse" role="button" :aria-expanded="!page.config.weekCollapsed && !pageOpened ? 'false' : 'true' " :aria-controls="uid + '-' + index" :href="'#' + uid + '-' + index">{{ showmoretext }} <i class="fas" :class="{'fa-arrow-down': !pageOpened , 'fa-arrow-up': pageOpened}" ></i></a>
                    </div>
                </div>
                </template>
            </div>
        </template>
    
    </div>
    </template>
    <script>
    export default {
         props: {
            disponibilita: {
                type: Array,
                default: () => []
            },
            cols: {
                type: Number,
                default: 6
            },
            visibleHoursBeforeHide: {
                type: Number,
                default: 5
            },
            showloader: {
                type: Boolean,
                default: true
            },
            promozioni: {
                type: Array,
                default: () => []
            },
            groupCollapse: {
                type: Boolean,
                default: false
            },
        },
        data: function() {
            return {
                isLoading: true,
                error: false,
                uid: null,
                viewuid: null,
                collapsed: true,
                updatingCalendar: false,
                currentPage: 0,
                pages: null,
                pagesContainer: null,
                cantGoBack: true,
                cantGoForward: false,
                pageOpened: false,
            }
        },
        watch: {
            cols: function(newVal, oldVal) {
                this.updateDisponibilita();
            },
            disponibilita: function(newVal, oldVal) {
                this.updateDisponibilita();
            },
            promozioni: function(newVal, oldVal) {
                this.updateDisponibilita();
            },
        },
        computed: {
            showmoretext: function() {
                const collapsed = this.pages[this.currentPage].config.weekCollapsed;
                return collapsed && !this.pageOpened ? 'altri orari' : 'riduci';
            },
        },
        mounted() {
            this.uid = 'calendar' + this._uid;
            this.viewuid = 'view-' + this.uid;
            this.updateDisponibilita();
        },
        methods: {
            eventTrack: function(eventName, eventValue = null) {
                if (!window.g4_event || !eventName) return;
                window.g4_event(eventName, {'event_category' : 'calendario', 'value' : eventValue });
            },
            scrollCalendarToView() {
                //check if mobile otherwise scrollIntoView will scroll the page
                if (window.innerWidth > 768) return;
                const el = document.getElementById(this.viewuid);
                if (! el) return;
                const top = el.getBoundingClientRect().top - 56;
                if (top > 550) {
                    el.scrollIntoView({
                        behavior: 'smooth',
                        'block': 'nearest',
                        'inline': 'nearest'
                    });
                }
            },
            toggleShowMore: function() {
                const weekCollapsed = !this.pages[this.currentPage].config.weekCollapsed;;
                this.pages[this.currentPage].config.weekCollapsed = weekCollapsed;
                this.pageOpened = !weekCollapsed;

                //force conversion value to string
                const eventValue = String(this.pageOpened ? 1 : 0);
                this.eventTrack('calendario_showmore', eventValue);

                if (this.groupCollapse) {
                    this.pages.map((page, index) => {
                        if (index == this.currentPage) return;
    
                        page.config.weekCollapsed = !page.config.weekShowMore ? false : weekCollapsed;
                        page.config.showClass = !page.config.weekShowMore ? true : this.pageOpened;
    
                        if (page.config.weekShowMore) {
                            $('#' + this.uid + '-' + index).collapse(weekCollapsed ? 'hide' : 'show');
                        }
                    });
                }
            },
            pageCantGoBack: function() {
                return this.currentPage <= 0;
            },
            pageCantGoForward: function() {
                return this.currentPage >= (this.pages.length - 1);
            },
            pageNavigationCheck: function() {
                this.cantGoBack = this.pageCantGoBack();
                this.cantGoForward = this.pageCantGoForward();
            },
            getNavigationPages: function() {
                const baseSelector = '#calendar-wrapper-' + this.uid + '-';
                const prev = this.currentPage <= 0 ? null : $(baseSelector + (this.currentPage - 1));
                const curr = $(baseSelector + this.currentPage);
                const next = this.currentPage >= (this.pages.length) ? null : $(baseSelector + (this.currentPage + 1));
                const results = {
                    prev,
                    curr,
                    next,
                };
                return results;
            },
            movePageToLeft: function(el, delay = 300, moveHidden = false) {
                this.scrollCalendarToView();
                this.updatingCalendar = true;
                el.animate({left: '-110%'}, delay, () => {
                    if(! moveHidden) el.css({ 'position': 'absolute'});
                    this.$nextTick(() => {
                        this.updatingCalendar = false;
                    });
                });
            },
            movePageToRight: function(el, delay = 300, moveHidden = false) {
                this.scrollCalendarToView();
                this.updatingCalendar = true;
                el.animate({left: '110%'}, delay, () => {
                    if(! moveHidden) el.css({ 'position': 'absolute'});
                    this.$nextTick(() => {
                        this.updatingCalendar = false;
                    });
                });
            },
            movePageToCurrent: function(el, delay = 300) {
                this.updatingCalendar = true;
                el.animate({left: '0'}, delay, () => {
                    el.css({ 'position': 'relative'});
                    this.$nextTick(() => {
                        this.updatingCalendar = false;
                    });
                });
            },
            nextPage: function(delayBetweenPages, moveHidden = false) {
                const index = this.currentPage + 1;
    
                if(index > this.pages.length) return;

                this.eventTrack('calendario_next', index);
    
                this.pushPage(index);
    
                this.$nextTick(() => {
                    const calendars = this.getNavigationPages();
                    if (! calendars.next) return;
    
                    this.movePageToLeft(calendars.curr, delayBetweenPages, moveHidden);
                    this.movePageToCurrent(calendars.next, delayBetweenPages);
    
                    this.currentPage++;
                    this.pageNavigationCheck();
                });
    
            },
            prevPage: function(delayBetweenPages, moveHidden = false) {
                const index = this.currentPage - 1;
                if(index < 0) return;

                this.eventTrack('calendario_prev', index);
    
                this.pushPage(index, true);
    
                this.$nextTick(() => {
                    const calendars = this.getNavigationPages();
                    if (! calendars.prev) return;
    
                    this.movePageToRight(calendars.curr, delayBetweenPages, moveHidden);
                    this.movePageToCurrent(calendars.prev);
    
                    this.currentPage--;
                    this.pageNavigationCheck();
                });
            },
            jumpToPage: function(index) {
                this.updatingCalendar = true;
                const oldCurrent = this.currentPage;
                const iter = oldCurrent + index;
                const base = '#calendar-wrapper-' + this.uid + '-';
                const baseSelector = base + iter;
                
                
                this.eventTrack('calendario_jump', String(iter));
                
                const delayBetweenPages = 150;
                const nav = this.getNavigationPages();

                this.pushPage(iter);
    
                this.$nextTick(() => {
                    this.movePageToLeft(nav.curr, delayBetweenPages);
                    this.movePageToCurrent($(baseSelector), delayBetweenPages);
    
                    this.currentPage = iter;
                    this.pageNavigationCheck();
    
                    //move pages between oldcurrent and current to the left, can't be skipped to avoid glitches
                    for (let i = oldCurrent + 1; i < iter; i++) {
                        const el = $(base + i);
                        if (!el) continue;
                        this.movePageToLeft(el, delayBetweenPages, true);
                    }
                });
            },
            pageExists: function(index) {
                return this.pagesContainer[index] ? true : false;
            },
            /**
             * push pages to this.pagesContainer
             * ahead and behind the current page
             **/
            pushPage: function(index, subtract = false) {
                let negativeIndex = index;
                let pages = [];
    
                for (let i = 0; i < 2; i++) {
    
                    if (! this.pageExists(index) && !pages[index] && index >= 0 && index < this.pages.length) {
                        this.pagesContainer[index] = this.pages[index];
                    }
    
                    if (! this.pageExists(negativeIndex) && !pages[index] && negativeIndex >= 0 && negativeIndex < this.pages.length) {
                        this.pagesContainer[negativeIndex] = this.pages[negativeIndex];
                    }
    
                    index = subtract ? index - 1 : index + 1;
                    negativeIndex = subtract ? negativeIndex + 1 : negativeIndex - 1;
                }
            },
            formatNextDisp: function(disp) {
                if (! disp) return null;
                return '<b>' + disp.giornoLocaleFull + ' ' + disp.giornoMeseFull + ' ' + disp.listOrari[0].ora_inizio + '</b>';
            },
            getNextDisp: function(startDate, disp) {
                let nextDisp = disp.filter(function (item) {
                    if (this.count > 0) return false;
                    if (moment(item.giorno, 'YYYY-MM-DD').isAfter(startDate))
                    {
                        this.count++;
                        return true;
                    }
    
                }, {count: 0});
                return nextDisp.length ? nextDisp[0] : null;
            },
            getDiffDays: function(from, to) {
                if (! from || ! to) return 0;
    
                const fromMoment = moment(from, 'YYYY-MM-DD');
                const toMoment = moment(to, 'YYYY-MM-DD');
                const diffDays = toMoment.diff(fromMoment, 'days');
                return diffDays;
            },
            weekDaysDisponibilita: function(disp) {
                this.isLoading = true;
                const domani = moment().add(1, 'days').startOf('day').format('YYYY-MM-DD');
                const maxDate = moment(disp[disp.length - 1].giorno, 'YYYY-MM-DD');
                const maxDateDiffDays = maxDate.diff(domani, 'days') + 1;
                const daysDivider = this.cols;
                const pageCounter = Math.ceil(maxDateDiffDays / daysDivider);
    
                let pagine = [];
                let weekHasDispBehind = false;
                let startDate = moment(domani, 'YYYY-MM-DD');
    
                for( let y = 0; y < pageCounter; y++) {
                    let weekHasSlots = false;
                    let nextDisp = null;
                    let nextDispPagesAhead = 0;
                    let weekShowMore = false;
                    let weekMaxHours = this.visibleHoursBeforeHide;
                    let datiPagina = [];
    
                    const isFirstPage = y == 0;
                    const isLastPage = y == (pageCounter - 1);
    
                    for (let i = 0; i < daysDivider; i++) {
    
                        const curDay = startDate.format('YYYY-MM-DD');
                        let resultData = disp.filter(item => item.giorno === curDay)[0] ?? undefined;
    
    
                        weekMaxHours = resultData?.listOrari?.length > weekMaxHours ? resultData.listOrari.length : weekMaxHours;
                        weekShowMore = weekShowMore || weekMaxHours > this.visibleHoursBeforeHide ? true : false;
                        weekHasSlots = weekHasSlots || resultData?.listOrari?.length > 0 ? true : false;
                        weekHasDispBehind = weekHasDispBehind || pagine[y - 1]?.config.weekHasSlots || false;
    
                        if (! resultData) {
                            resultData = this.formatGiorniDisponibilita({
                                giorno: curDay,
                                listOrari: [],
                                dayHasDisponibilita: false,
                                showMore: false,
                            });
    
                            nextDisp = this.getNextDisp(startDate, disp);
    
                            if (nextDisp) {
                                //get the differences in days to nextDisp
                                const diffDays = this.getDiffDays(startDate, nextDisp.giorno);
                                nextDispPagesAhead = Math.ceil(diffDays / daysDivider);
                            }
                        } else {
                            resultData.dayHasDisponibilita = true;
                        }
    
                        datiPagina.push(resultData);
                        startDate.add(1, 'days');
                    }
    
                    const weekTextNextDisp = weekHasDispBehind ? 'Prossima' : 'Prima';
                    //push page
                    let curPage = [...datiPagina];
                    const config = {
                        weekHasSlots,
                        nextDispPagesAhead,
                        weekHasDispBehind,
                        weekShowMore,
                        weekMaxHours,
                        weekTextNextDisp,
                        nextDisp: this.formatNextDisp(nextDisp) ?? null,
                        weekCollapsed: true,
                        isFirstPage,
                        isLastPage,
                    };
    
                    pagine.push({config, disp: curPage});
                }
    
                this.pages = pagine;
                //push only first 2 pages to this.pagesContainer
                this.pagesContainer = pagine.slice(0, 2);
    
                this.isLoading = false;
                this.pageNavigationCheck();
            },
            formatGiorniDisponibilita: function(disp) {
                const domani = moment().add(1, 'days').format('YYYY-MM-DD');
                const giornata = moment(disp.giorno, 'YYYY-MM-DD');
                const ggDate = giornata.format('YYYY-MM-DD');
    
                disp.giornoLocale = ggDate == domani ? 'domani' : giornata.locale('it').format('ddd');
                disp.giornoMese = giornata.locale('it').format('DD MMM');
                disp.giornoLocaleFull = ggDate == domani ? 'domani' : giornata.locale('it').format('dddd');
                disp.giornoMeseFull = giornata.locale('it').format('DD MMMM');
    
                disp.hasPromo = false;
    
                if (this.promozioni.length) {
                    disp.hasPromo = this.dayInPromo(disp.giorno);
                }
    
                return disp;
            },
            dayInPromo: function(giorno) {
                return this.promozioni.find(p => p.datainizio.isSameOrBefore(giorno) && p.datafine.isSameOrAfter(giorno));
            },
            updateDisponibilita: async function() {
                await this.resetCalendar();
                this.isLoading = true;
    
                if (! this.disponibilita?.length) {
                    return;
                }
    
                const disp = Object.assign([], this.disponibilita);
                disp.map(item => this.formatGiorniDisponibilita(item));
                this.weekDaysDisponibilita(disp);
    
                this.isLoading = false;
            },
            resetCalendar: async function() {
                /**
                 * Devo distruggere il dom altrimenti si inceppa nei resize!
                 */
                return new Promise((resolve, reject) => {
                    this.pages = null;
                    this.pagesContainer = null;
                    this.error = false;
                    this.collapsed = true;
                    this.currentPage = 0;
                    this.pageOpened = false;
                    this.openedPageOn = null;
                    return resolve();
                });
            },
            touchStartMethod (touchEvent) {
                if (touchEvent.changedTouches.length !== 1) {
                    return;
                }
                const posXStart = touchEvent.changedTouches[0].clientX;
                const posYStart = touchEvent.changedTouches[0].clientY;
                addEventListener('touchend', (touchEvent) => this.touchEndMethod(touchEvent, posXStart, posYStart), {once: true});
            },
            touchEndMethod (touchEvent, posXStart, posYStart) {
                if (touchEvent.changedTouches.length !== 1) {
                    return;
                }
    
                const posXEnd = touchEvent.changedTouches[0].clientX;
                const posYEnd = touchEvent.changedTouches[0].clientY;
                const diffX = posXStart - posXEnd;
                const diffY = posYStart - posYEnd;
    
                const threshold = 10;
                const absDiffX = Math.abs(diffX);
                const absDiffY = Math.abs(diffY);
    
                //try to detect if it's a swipe or a tap
                if (absDiffX < threshold && absDiffY < threshold) {
                    return;
                }
    
                if (absDiffX < absDiffY) {
                    return;
                }
    
                if (posXStart < posXEnd && this.currentPage > 0) {
                    this.prevPage(); // swipe right
                } else if (posXStart > posXEnd && this.currentPage < this.pages.length - 1) {
                    this.nextPage(); // swipe left
                }
            }
        }
    }
    </script>
    